export class Sede {
    public icon = 'fa fa-map-marker prefix text-primary';
    public title = 'Sede';
    public list = [];
}



// WEBPACK FOOTER //
// ./src/app/shared/domain/sedes.ts